

import { ContainerIcon } from "../Icons/ComponentIcons";
import {  ResizeableType, WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { CreateAttributeListWithParams, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { AttributeCollection } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { SiteData } from "../Data/SiteData";
import { UpdateStyleFunction } from "../Stylebuilder";







export default class WBTabContainer extends WBComponent {

    


    constructor(){
        super();
        this.typename =wBComponentTypeNames.tabContainer;
        this.displayName = "Tab Content";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = ["alignment-full",attributeTypes.flexDirection,"justifyVertical","justifyHorizontal","alignHorizontal","alignVertical","gap","flexWrap"];
        this.editList = [attributeTypes.flexDirection,"gap", attributeTypes.justifyContent,attributeTypes.alignContent,attributeTypes.alignItems, ...CreateAttributeListWithParams({background:true,shape:true})];
        this.contentEditable = false;
        this.icon = <ContainerIcon/>
        this.isStatic = true;
        this.resizeType = ResizeableType.All;
        this.resizeVisibilty = [false,false,false];
        this.isSubComponent = true;
        
    }


    RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData, }: { updateFunc: UpdateStyleFunction; saveFunc: Function; editList: string[]; primaryList: string[]; layoutNode: AttributeCollection | null; screenSize: ScreenSize; showScreenSize?: boolean; siteData: SiteData; }): JSX.Element {
        return <>
        
        {super.RenderMenu({editList,primaryList,layoutNode,screenSize,updateFunc,saveFunc,showScreenSize,siteData})}
        <div className="global-apply-container">
        <button
       
            className="menu-button"
        onClick={()=>{
            let node = layoutNode as LayoutNode;
            let parent = node.parent;
            if(parent){
                let children = parent.children;
                for(let i = 0;i<children.length;i++){
                    let child = children[i];
                    if(child.typename == wBComponentTypeNames.tabContainer){
                        
                        let atts = {...node.componentAttributes}
                        let screenSizes = [{...node.screenSizeStyleAttributes[0]},{...node.screenSizeStyleAttributes[1]},{...node.screenSizeStyleAttributes[2]}];

                        child.componentAttributes = atts;
                        child.screenSizeStyleAttributes = screenSizes;
                        saveFunc();
                     
                    }
                }
            }


        }}
        
        >Apply to All Tabs</button></div>
        </>
    }

    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps)
     {
        let index = component.parent?.children.indexOf(component);
        let atts = GetNodeDomAttributes("v-tab-container justify-center align-center h-full w-full v-tab-container-"+index,component,screenSize,isEditor);

        

        return (
        <div {...atts}   >
                {children}
        </div>
        );
   
    }

}